import { useContext, useState } from "react";
import Paragraph from "../../../elements/p/Paragraph";
import ButtonAction from "../../../elements/buttons/ButtonAction";
import modalContext from "../../../../dataManager/context/modalContext";
import { changeUserAlreadyVisitedByAdmin } from "../../../../api/users/usersApi";
import { toast } from "react-toastify";

const ChangeUserAlreadyContacted = () => {
  //context section
  const { onClose, modalParams } = useContext(modalContext);

  //state variables
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  //some handler
  const handleClick = async (id) => {
    //start loading
    setLoading(true);

    console.log(modalParams.userId);

    //delete user to the list
    const { data, error } = await changeUserAlreadyVisitedByAdmin(id);

    if (error) {
      setError(error);
      return setLoading(false);
    }

    setLoading(false);
    onClose();
    toast.success("Utilisateur supprimé de votre liste des prospects", {
      theme: "colored",
    });
  };

  return (
    <div className="w-full">
      <Paragraph>
        Vous allez supprimer cet utilisateur de la liste des personnes dont vous
        allez prospecter dans le futur sans pour autant supprimer son compte.
        êtes vous sûre de vouloir continuer ?
      </Paragraph>
      <div className="mt-4 flex items-center">
        <ButtonAction
          size="small"
          loading={loading}
          onClick={() => handleClick(modalParams.userId)}
        >
          Supprimer
        </ButtonAction>
        <ButtonAction size="small" type="secondary" onClick={onClose}>
          Anuler
        </ButtonAction>
      </div>

      <span className="mt-1 font-nunito text-sm text-[#fc3838]">
        {error && error}
      </span>
    </div>
  );
};

export default ChangeUserAlreadyContacted;
